import React, { useState } from "react"
import SearchProgressive from "@/components/Search/v1/SearchProgressive"
import closeIcon from "@/public/icons/Close Icon.svg"
import searchWrapperStyle from "@/components/Search/v1/SearchView/index.module.scss"
import { useTranslation } from "next-i18next"
import { getTranslations } from "@/components/Default/DynamicSearch/v1/SearchPanel/localization"
import useSearchi18n from "@/i18n/useSearchi18n"
const OuterSearchProgressive = () => {
  const { t } = useTranslation("common")
  const staticText = useSearchi18n({})
  const [staticTexts] = useState(getTranslations(t))
  return (
    <div className={`${searchWrapperStyle?.searchViewStyleWrapper} Plp-Search`}>
      <div className="search-result">
        <div className="container-fluid">
          <div className="product-listing__row no-gutters">
            <div className="product-listing__col search-result__breadcrumb-header  --no-results">
              <div className="search-result__breadcrumb kf-react-plp-container">
                <nav>
                  <ol>
                    <li>
                      <a href="#">{staticTexts?.globalHome}</a>
                      {" / "}
                    </li>
                    <li>
                      <a href="#">{staticText?.searchResults}</a>
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="search-result__header search-result--no-background">
                <div className="kf-react-plp-container">
                  <div className="search-result__search-header">
                    <div className="search-result__description">
                      <div
                        role="alert"
                        aria-live="polite"
                        className="search-result__showing --no-results"
                      >
                        {staticText?.loading} {staticText?.results}
                      </div>
                    </div>
                    <div className="search-result__search-field">
                      <input
                        type="text"
                        id="search_close_button"
                        className="search-result__search-control"
                        autoFocus
                        placeholder="Search Kohler"
                        aria-label={
                          staticTexts?.ariaLabel?.searchInputAriaLabel
                        }
                      />
                      <a
                        className={`search-result__close-button`}
                        role="button"
                        tabIndex="0"
                      >
                        <img src={closeIcon?.src} alt="close-icon" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <SearchProgressive />
        </div>
      </div>
    </div>
  )
}

export default OuterSearchProgressive
